/* eslint-disable no-restricted-syntax */
/* this script gets built so it's fine to use ES6 features */

/**
 * AoPS.ClassWallet
 */
class ClassWallet {
	/**
	 * Quickly check whether a ClassWallet session exists without checking secret.
	 * Returns true if a cookie called `cw` is known to the browser.
	 * @return boolean true if ClassWallet session, false otherwise
	 */
	checkSessionQuick() {
		return !!document.cookie.match(/^(.*;)?\s*cw\s*=\s*[^;]+(.*)?$/);
	}

	/**
	 * Checks if ClassWallet is allowed for a given class.
	 * We allow self-paced classes to be purchased through ClassWallet.
	 * This is currently only allowed in NH
	 * NOTE: If you ever change the logic of this function
	 * you should also change the php function with the same name in class.ClassWallet.php
	 * @param bool $is_self_paced
	 * @return bool
	 */
	allowClasswalletForClass(is_self_paced) {
		const inAllowedState =
			AoPS.bd.classWallet &&
			AoPS.bd.classWallet.customerInfo &&
			AoPS.bd.classWallet.allowedStates.includes(
				AoPS.bd.classWallet.customerInfo.shipping.state
			);
		return !this.checkSessionQuick() || (is_self_paced && inAllowedState);
	}

	/**
	 * Destroys the current ClassWallet session.
	 * Note this cannot be used to destroy an arbitrary session,
	 * only the current user's session. This not only destroys
	 * both ClassWallet cookies, but also resets cart data.
	 * @see `destroySession` in aops/includes/class.ClassWallet.php
	 */
	exitSession() {
		$.post("/m/classwallet/ajax.php", {action: "destroy-session"}, (data) => {
			if (data && data.response && data.response.status) {
				AoPS.Ui.Modal.showAlertQuick(
					`${data.response.status}. The page needs to refresh.`,
					{
						onClose: location.reload.bind(location),
						alert_button_ok: "Refresh",
					}
				);
			} else {
				AoPS.Ui.Modal.showAlertQuick("An unknown error occurred.");
			}
		});
	}

	/**
	 * Shows the user a warning modal indicating
	 * that their selected product cannot be purchased via ClassWallet.
	 * As of writing this comment, this currently applies to everything
	 * that isn't a book or merchandise.
	 */
	showBadItemModal() {
		AoPS.Ui.Modal.closeAllModals();
		let message = `<p>This item may not be purchased through ClassWallet in your state, but physical and online books are available.</p>
			<p>If you would like to purchase this item, please exit the ClassWallet session.</p>`;
		let buttons = [
			{
				text: "Explore Books",
				value: "explore-books",
			},
			{
				text: "Exit ClassWallet",
				value: "exit",
			},
		];

		// If you can purchase SP classes, show a slightly different message
		if (
			AoPS.bd.classWallet.allowedStates.includes(
				AoPS.bd.classWallet.customerInfo.shipping.state
			)
		) {
			message = `<p>This item may not be purchased through ClassWallet in your state. To continue with ClassWallet, select a self-paced course or book option.</p>
						<p>If you would like to purchase this item, please exit the ClassWallet session.</p>`;
			buttons = [
				{
					text: "Continue with ClassWallet",
					value: "continue",
				},
				{
					text: "Exit ClassWallet",
					value: "exit",
				},
			];
		}
		AoPS.Ui.Modal.showAlertQuick(message, {
			type: "buttons",
			buttons: buttons,
			onButtonClick: (value) => {
				if (value === "explore-books") {
					window.location.href = "/store";
				} else if (value === "exit") {
					AoPS.ClassWallet.exitSession();
				}
				return false;
			},
		});
	}

	/**
	 * This function handles the ClassWallet click event for "add to cart" buttons.
	 * The handler helps prevent users from checking out invalid items with ClassWallet.
	 * @param {PointerEvent} event
	 */
	buttonClickHandler(event) {
		if (!AoPS.ClassWallet.checkSessionQuick()) {
			return;
		}

		// If the button has a data-sku attribute, it's a product
		// Self-Paced classes are okay now too.
		const $button = $(event.target);
		const sku = $button.attr("data-sku");
		const isSelfPaced = $button.hasClass("is-self-paced");
		if (sku || AoPS.ClassWallet.allowClasswalletForClass(isSelfPaced)) {
			return;
		}

		// This isn't a product the user can purchase through CW
		event.preventDefault(); // Prevent form submission for gift certificates
		AoPS.ClassWallet.showBadItemModal();
	}

	/**
	 * Adds ClassWallet click event listener to all specified buttons.
	 * Ensures that we wait for buttons to render as needed.
	 * @param {string} selector CSS selector of the ClassWallet buttons
	 */
	addListenerToButtons(selector) {
		$(document).on("click", selector, AoPS.ClassWallet.buttonClickHandler);
	}
}

/**
 * Adds ClassWallet to the AoPS keychain.
 * Only one ClassWallet object should exist per client session.
 * This is the only way that the ClassWallet class should be instantiated,
 * and this function should not be called in any other file.
 */
const addClassWalletToAoPS = () => {
	if (AoPS.hasOwnProperty("ClassWallet")) {
		// Already defined
		return;
	}

	// Create the class
	AoPS.ClassWallet = Object.create(ClassWallet.prototype);

	// Listen to button clicks everywhere this script gets loaded
	AoPS.ClassWallet.BUTTON_SELECTOR = ".btn-classwallet";
	AoPS.ClassWallet.addListenerToButtons(AoPS.ClassWallet.BUTTON_SELECTOR);
};

addClassWalletToAoPS();
